export const customStyles = {
  paperCard: {
    backgroundColor: '#FBF9F5',
    boxShadow: '0 10px 30px -5px rgba(0,0,0,0.1), 0 4px 10px -2px rgba(0,0,0,0.05)',
    border: '1px solid rgba(0,0,0,0.05)',
    position: 'relative',
  },
  gridBg: {
    backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
    backgroundSize: '20px 20px',
  },
  stripedTop: {
    background: 'repeating-linear-gradient(45deg,#b7eb6f,#b7eb6f 10px,#F4F1EA 10px,#F4F1EA 20px)',
  },
};
